<template src="./template.html"></template>
<style src="./page.scss" lang="scss"></style>

<script>
  import cmsPageMixin from '@/mixins/cmsPageMixin'

  export default {
    name: 'CMSPage',
    mixins: [cmsPageMixin],
  }
</script>
